import React, { useContext } from 'react';
import { A11y, EffectFade, Virtual } from 'swiper';

import { app, media } from 'context';
import { Grid, Layout, Text } from 'ds';
import { NO_SWIPING_CLASS } from 'ds/SwiperCarousel';
import { Swiper, SwiperSlide as Slide } from 'swiper/react';

import ServiceCard from './ServiceCard';

interface Props {}

const SERVICES = [
  {
    title: 'Furniture & design',
    href: '/furniture',
    srcKey: 'home-page-service-furniture_pbHVXdAQ2.jpg'
  },
  {
    title: 'Cleaning service',
    href: '/cleaning',
    srcKey: 'home-page-service-cleaning_MVAY2s1dP.jpg'
  },
  {
    title: 'Supplies & restocking',
    href: '/restocking',
    srcKey: 'home-page-service-restocking_iVYBMxuTC.png'
  }
];

const Services: React.FC<Props> = () => {
  const { isMobile, xs, md, lg } = useContext(media);
  const { contentPaddingX, windowWidth } = useContext(app);
  const isMouse = md || lg;

  return (
    <Layout paddingY={xs ? 64 : 100}>
      <Layout {...(isMobile ? { paddingX: contentPaddingX } : {})}>
        <Text
          size={isMobile ? 'headline-lg' : 'display-sm'}
          color="blue-500"
          {...(isMobile ? {} : { align: 'center' })}
        >
          Discover our services
        </Text>
        <Layout marginTop={32}>
          <Text size="body-md" color="gray-400" {...(isMobile ? {} : { align: 'center' })}>
            Everything you need to thrive in your office.
          </Text>
        </Layout>
      </Layout>
      {isMobile || md ? (
        <Layout width={windowWidth} marginTop={32} position="relative" left={xs ? undefined : -contentPaddingX}>
          <Swiper
            slidesPerView={md ? 1.6 : 1.2}
            spaceBetween={md ? 20 : 12}
            style={{ paddingLeft: contentPaddingX, paddingRight: contentPaddingX }}
            modules={[A11y, Virtual, EffectFade]}
            noSwiping={isMouse}
            noSwipingClass={NO_SWIPING_CLASS}
          >
            {SERVICES.map(({ title, href, srcKey }) => {
              return (
                <Slide key={title}>
                  <ServiceCard title={title} href={href} srcKey={srcKey} />
                </Slide>
              );
            })}
          </Swiper>
        </Layout>
      ) : (
        <Layout marginTop={32}>
          <Grid itemsPerRow={3} gapX={24}>
            {SERVICES.map(({ title, href, srcKey }) => {
              return <ServiceCard key={title} title={title} href={href} srcKey={srcKey} />;
            })}
          </Grid>
        </Layout>
      )}
    </Layout>
  );
};

export default Services;
